/*jslint browser */
/*global process */

import Item from "../../entity/item";
import ImageCombiner from "../../utils/imageCombiner";
import IdGenerator from "../../utils/id.generator";

var $ = jQuery;
declare var document: any;
declare var window: any;
declare var xtAjaxurl: string;
declare var sessionStorage: any;
declare var navigator: any;

/**
 *
 */
export default class Configurator
{
    private _colourBoxes: JQuery;
    private _configuratorItem: JQuery;
    private _configurableProductParts: JQuery;
    private _addToStorage: JQuery;
    private _configuratorSelected: Array<Item> = [];
    private _productAdditionalPrice: JQuery;
    private _imageCombiner: ImageCombiner;
    private _imageThumbnailCombiner: ImageCombiner;
    private _productImage: JQuery;
    private _productImageMarker: JQuery;
    private _generatePdf: JQuery;
    private _productId: number;
    private _xtSingleAddToCartButton: JQuery;
    private _configurableImg: JQuery;

    constructor() {
    }

    public init(): void {
        this.registerEvents();
        this.setImageCombiner();
        this.refreschConfigurator();
    }

    public changeAccessoryChecboxStatus(ob: JQuery) {
        const id = ob.data('id');
        $('.select-accessory-' + id).trigger('click');
        if($('.select-accessory-' + id).is(':checked')) {
            ob.addClass('selected-accessory-box');
        } else {
            ob.removeClass('selected-accessory-box');
        }
    }

    public changeItem(ob: JQuery): void {
        this.refreshSelectedItems(ob);
        this.refreschConfigurator();
    }

    public generatePdf(): void {
        this.generatePdfDoc();
    }

    public setMainProductId(id: number) {
        this._productId = id;
    }

    private registerEvents(): void {
        this._configuratorItem = $('.configurator-item');
        this._configurableProductParts = $('#configurable_product_parts');
        this._productAdditionalPrice = $('#product_additional_price');
        this._addToStorage = $('.add-to-storage');
        this._productImage = $('.product-image');
        this._generatePdf = $('.generate-pdf');
        this._xtSingleAddToCartButton = $('.xt-single_add_to_cart_button');
        this._configurableImg = $('#configurable_img');
        //$('.data-image').css('display', 'none');
        //$('.data-image-thumbnail').css('display', 'none');

        var isMobile = false;
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
            isMobile = true;
        }

        this._productImage.parents('.elementor-element-populated').removeClass('elementor-widget-wrap');
        $(document).on('scroll', (e) => {
            if(!isMobile) {
                this.imagePositionControll($(document));
            }
        })

        this._xtSingleAddToCartButton.on('click', (e) => {
            this.xtSingleAddToCartButtonClick();
        })
    }

    private imagePositionControll(ob: JQuery): void {
        if($('.img-marker').length) {
            let pos = $('.img-marker').position().top;
            const checkPos = $('.img-marker').offset().top;
            const checkEntryPos = $('.entry-title').offset().top;

            if(ob.scrollTop() < (checkEntryPos - 200)) { //100
                this._productImage.css('position', 'relative');
                this._productImage.css('top', '');
            //} else if (ob.scrollTop() < (checkPos - 100)) {
            } else if (ob.scrollTop() >= (checkEntryPos - 200) && (ob.scrollTop() - checkEntryPos + 100)  < pos) {
                this._productImage.css('position', 'fixed');
                this._productImage.css('top', 100); //wysokość po zaczepieniu
            } else {
                this._productImage.css('position', 'relative');
                pos = pos + 100;
                //this._productImage.css('top', pos);
                this._productImage.css('top', pos);
            }
        }
    }

    private setImageCombiner(): void {
        if($('#configurator-image').length) {
            this._imageCombiner = new ImageCombiner('configurator-image');
            this._imageThumbnailCombiner = new ImageCombiner('configurator-image-thumbnail');
            //this._imageCombiner.setCanvasWidth(450);
            this._imageCombiner.setCanvasWidth(650);
            this._imageCombiner.setCanvasHeight(586);
            this._imageThumbnailCombiner.setCanvasWidth(150);
        }
    }

    private refreshSelectedItems(ob: JQuery): void {
        const type = ob.data('type');
        $('.selected-' + type + '-item').text(ob.data('name'));
        if(!ob.hasClass('selected-item')) {
            $('.configurator-item-' + type).removeClass('selected-item');
            ob.addClass('selected-item');
        }
    }

    private refreschConfigurator(): void {
        this._configuratorSelected = [];
        this.updateCartData();
        this.updatePrice();
        this.setStorageData();
        this.updateProductImage();
    }

    private updateCartData(): void {
        this.collectItemData();
        this.setConfiguratorData();
    }

    private collectItemData(): void {
        const thisObject = this;
        this._configuratorItem.each(function () {
            if($(this).hasClass('selected-item')) {
                thisObject.addItem($(this));
            }
        })
    }

    private addItem(ob: JQuery): void {
        const item = new Item();
        item.id = ob.data('id') as unknown as number;
        item.name = ob.data('name');
        item.type = ob.data('type');
        item.price = ob.data('price') as unknown as number;
        item.generatorImegeUrl = ob.data('generator-image');

        this._configuratorSelected.push(item);
    }

    private setConfiguratorData(): void {
        const serializedData = JSON.stringify(this._configuratorSelected);
        this._configurableProductParts.val(serializedData);
    }

    private updatePrice(): void {
        this.updateAdditionalPrice();
    }

    private updateAdditionalPrice(): void {
        let price = 0;
        for (const [key, item] of Object.entries(this._configuratorSelected)) {
            price += item.price
        }
        this._productAdditionalPrice.val(price);
        this._productAdditionalPrice.trigger('change');
    }

    private setStorageData(): void {
        let object: any = [];
        for (const [key, item] of Object.entries(this._configuratorSelected)) {
            object.push(item.id);
        }
        const json = JSON.stringify(object);
        this._addToStorage.attr( "data-items", json );
    }

    private updateProductImage(): void {
        // @ts-ignore
        const imagePartList: Record<string, any> = {};
        // @ts-ignore
        const imageThumbnailPartList: Record<string, any> = {};
        let i = 0;
        let j = 0;
        let elementsCount = this._configuratorSelected.length;

        for (const [key, item] of Object.entries(this._configuratorSelected)) {

            const ob = this;
            const img = window.document.createElement('img');
            $(img).on('load', function() {
                i++;
                imagePartList[item.type] = img;

                if(i == elementsCount) {
                    // @ts-ignore
                    ob.drawImage(ob._imageCombiner, imagePartList);
                }

            });
            img.src = $('.data-image-' + item.id).data('src');

            const imgThumbnail = window.document.createElement('img');
            $(imgThumbnail).on('load', function() {
                j++;
                imageThumbnailPartList[item.type] = imgThumbnail;

                if(j == elementsCount) {
                    // @ts-ignore
                    ob.drawImage(ob._imageThumbnailCombiner, imageThumbnailPartList);

                    sessionStorage.setItem("current_created_img", ob._imageThumbnailCombiner.getImageUrl());
                    const idGenerator = new IdGenerator();
                    ob._configurableImg.val(idGenerator.generate());
                    ob._addToStorage.attr('data-image', 'base64');
                }

            });
            imgThumbnail.src = $('.data-image-thumbnail-' + item.id).data('src');
        }
    }

    private drawImage(combiner: any, listOfImages: Record<string, any>): void {;
        combiner.clearCanvas();
        if(listOfImages.hasOwnProperty('colour'))
        {
            combiner.drawImage(listOfImages['colour']);
        }
        if(listOfImages.hasOwnProperty('finishes'))
        {
            combiner.drawImage(listOfImages['finishes']);
        }
        if(listOfImages.hasOwnProperty('plan'))
        {
            combiner.drawImage(listOfImages['plan']);
        }

        /*for(let imageId in listOfImages) {
            if(this.isImage(listOfImages[imageId])) {
                combiner.drawImage(listOfImages[imageId]);
            }
        }*/
    }

    private isImage(i: any): boolean {
        // @ts-ignore
        if(i instanceof HTMLImageElement) {
            return true
        }

        return false
    }

    private generatePdfDoc() {
        let colour = null;
        let finishes = null;
        let plan = null;
        for (const [key, item] of Object.entries(this._configuratorSelected)) {
            if(item.type == 'colour') {
                colour = item.id
            }
            if(item.type == 'finishes') {
                finishes = item.id
            }
            if(item.type == 'plan') {
                plan = item.id
            }
        }

        const ajaxData = {
            'action': 'main_ajax',
            'controller': 'AjaxController',
            'run': 'generateConfiguratedProductPdf',
            'productId': this._productId,
            'productImage': this._imageCombiner.getImageUrl(),
            'colour': colour,
            'finishes': finishes,
            'plan': plan,
        }

        const configurator = this;
        this.blockButton();
        $.post(xtAjaxurl, ajaxData, function(response) {
            configurator.releaseButton();
            configurator.saveToDisk(response.link, configurator.generateFileName());
        });
    }

    public blockButton(): void
    {
        //this._tempSubmitButtonText = this._makeStoragePdf.text();
        //this._pdfGeneratorMessage.text('Generowanie...');
        this._generatePdf.prop('disabled', true);
    }

    public releaseButton(): void
    {
        //this._makeStoragePdf.text(this._tempSubmitButtonText);
        //this._pdfGeneratorMessage.text('');
        this._generatePdf.prop('disabled', false);
    }

    public saveToDisk(fileURL: any, fileName: any): void {
        // for non-IE
        if (!window.ActiveXObject) {
            var save = document.createElement('a');
            save.href = fileURL;
            save.target = '_blank';
            save.download = fileName || 'unknown';

            // @ts-ignore
            var evt = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': false
            });
            save.dispatchEvent(evt);

            (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }

        // for IE < 11
        else if ( !! window.ActiveXObject && document.execCommand)     {
            var _window = window.open(fileURL, '_blank');
            _window.document.close();
            _window.document.execCommand('SaveAs', true, fileName || fileURL)
            _window.close();
        }
    }

    private generateFileName(): string {
        const today = new Date();
        const date = today.getFullYear()+'_'+(today.getMonth()+1)+'_'+today.getDate();
        const time = today.getHours() + "_" + today.getMinutes() + "_" + today.getSeconds();
        const dateTime = date+'_'+time;

        return dateTime + '_product';
    }

    private xtSingleAddToCartButtonClick(): void {
        this.saveGeneratedImage();
    }

    private saveGeneratedImage(): void {
        const imgKey = this._configurableImg.val();
        const img64 = sessionStorage.getItem('current_created_img');
        const ajaxData = {
            'action': 'main_ajax',
            'controller': 'AjaxController',
            'run': 'saveGeneratedImage',
            'img': img64,
            'productId': 0,
            'imgKey': imgKey,
            'type': 'order'
        }

        $.post(xtAjaxurl, ajaxData, function(response) {

        });
    }
}